import { useTranslation } from 'react-i18next'

import NumericInput from '../common/components/formInputs/NumericInput'
import TicketsSection from '../common/components/formInputs/TicketsSection'
import FormInput from '../common/components/formInputs/FormInput'
import TextField from '../../../components/FormLegacy/FormFieldsV2/TextField'

const ThirdStep = ({ displayStep, formValues, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])
  const advancedTicketingEnabled = !!formValues.building?.eventTicketsAvailable

  if (!displayStep) {
    return null
  }

  const { capacity, tickets } = formValues

  return (
    <>
      <div className="columns">
        <NumericInput
          columnSize={advancedTicketingEnabled ? 12 : 6}
          name="capacity"
          label={t('eventManagement:classFormPage.thirdStep.capacityLabel')}
          value={capacity}
          setFieldValue={setFieldValue}
          onlyIntegers
        />
        {!advancedTicketingEnabled && (
          <div className="column is-6">
            <FormInput label="Price, $" name="price">
              <TextField
                type="number"
                onlyIntegers
                onChange={(e) => {
                  const value = e.target.value
                  const maxPrice = 1000000

                  if (value.includes('.')) {
                    return
                  }

                  if (parseFloat(value) > maxPrice) {
                    setFieldValue(`tickets[0].price`, value)
                    return
                  }

                  setFieldValue(`tickets[0].price`, value)
                }}
                value={tickets[0].price}
                min={0}
              />
            </FormInput>
          </div>
        )}
      </div>
      {advancedTicketingEnabled && (
        <TicketsSection
          name="tickets"
          tickets={tickets}
          setFieldValue={setFieldValue}
          advancedTicketingEnabled={advancedTicketingEnabled}
          addingAdditionalTicketsEnabled={false}
        />
      )}
    </>
  )
}

export default ThirdStep
